import React, {Suspense} from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom'

import {initializeApp} from "firebase/app"
import {getAnalytics} from "firebase/analytics"

import {createTheme, CssBaseline, ThemeProvider} from "@mui/material"

import Home from "./components/Home"


const config = {
    apiKey           : process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain       : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL      : process.env.REACT_APP_FIREBASE_DB_URL,
    projectId        : process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket    : process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDERID,
    appId            : process.env.REACT_APP_FIREBASE_APPID,
    measurementId    : process.env.REACT_APP_FIREBASE_MEASUREMENTID
}

const app = initializeApp(config)
const analytics = getAnalytics(app)


const Bo = React.lazy(() => import(/* webpackChunkName: "bo" */'./components/bo'))
const Signin = React.lazy(() => import(/* webpackChunkName: "bo" */'./components/bo/Signin'))
const Reset = React.lazy(() => import(/* webpackChunkName: "bo" */'./components/bo/Reset'))

const theme = createTheme({
    palette: {
        primary: {
            main: '#C53F69'
        }
    }
})

ReactDOM.render(
    <React.StrictMode>
        <CssBaseline/>
        <ThemeProvider theme={theme}>
            <Suspense fallback={<div>Chargement de l'application...</div>}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/bo/*" element={<Bo/>}/>
                        <Route path="/signin" element={<Signin/>}/>
                        <Route path="/reset" element={<Reset/>}/>
                        <Route path="/*" element={<Navigate to="/"/>}/>
                    </Routes>
                </BrowserRouter>
            </Suspense>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
)


